/**
 * Collection Watches Presenter
 */
class CollectionWatchesPresenter extends AbstractProductsPresenter {

	constructor(sectionId, collectionUrl, collectionTitle) {

		super();
		this.view = new CollectionWatchesView(this, sectionId, collectionTitle);
		
		/*
		 * Listeners
		 */

		/*
		 * Initialisation
		 */

		// setup the url and retrieve the collection data from shopify
		const sorting = this.view.getSortingDefault();
		const url = collectionUrl + "?section_id=collection-watches-data-section&sort_by=" + sorting.value;
		this.retrieveData(url, 1);

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

}